import React from 'react';
import styled from 'styled-components';
import { FiPlus } from 'react-icons/fi';
import { Container } from '../ui';
import { LocationFaqItem } from '../../types/location';
import { Band, Eyebrow, SectionHeading, hairline, ink } from './tokens';

const Split = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 4fr) minmax(0, 7fr);
  gap: clamp(2rem, 5vw, 5rem);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const List = styled.div`
  border-top: 1px solid ${({ theme }) => hairline(theme)};
`;

const Item = styled.details`
  border-bottom: 1px solid ${({ theme }) => hairline(theme)};

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.3rem 0;
    cursor: pointer;
    list-style: none;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 500;
    font-size: 1.08rem;
    color: ${({ theme }) => ink(theme)};
  }
  summary::-webkit-details-marker { display: none; }

  summary svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.primary};
    transition: transform 0.25s ease;
  }
  &[open] summary svg { transform: rotate(45deg); }

  p {
    padding: 0 2.5rem 1.4rem 0;
    color: ${({ theme }) => theme.colors.neutral[700]};
    line-height: 1.8;
    white-space: pre-line;
  }
`;

const LocationFaq: React.FC<{ name: string; items: LocationFaqItem[] }> = ({ name, items }) => {
  if (items.length === 0) return null;
  return (
    <Band aria-labelledby="local-faq">
      <Container>
        <Split>
          <div>
            <Eyebrow>{name}</Eyebrow>
            <SectionHeading id="local-faq">Perguntas frequentes</SectionHeading>
          </div>
          <List>
            {items.map((item, index) => (
              <Item key={item.question} open={index === 0}>
                <summary>
                  {item.question}
                  <FiPlus size={20} aria-hidden />
                </summary>
                <p>{item.answer}</p>
              </Item>
            ))}
          </List>
        </Split>
      </Container>
    </Band>
  );
};

export default LocationFaq;
